import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { SUPABASE_CLIENT } from "../src/Services/Supabase";

const AUTO_LOGOUT_MINUTES = 10;

export const useAutoLogout = () => {
  const navigate = useNavigate();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const logoutUser = async () => {
    await SUPABASE_CLIENT.auth.signOut();
    localStorage.removeItem("supabase.auth.token"); // optional
    navigate("/"); // or your login route
  };

  const resetTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(logoutUser, AUTO_LOGOUT_MINUTES * 60 * 1000);
  };

  useEffect(() => {
    // Reset on any of these events
    const events = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"];

    for (const event of events) {
      window.addEventListener(event, resetTimer);
    }

    // Initial timer start
    resetTimer();

    return () => {
      for (const event of events) {
        window.removeEventListener(event, resetTimer);
      }
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
};
